msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/i18n/remote.tsx
msgid "{added} added lines, {deleted} deleted lines"
msgstr "{added} added lines, {deleted} deleted lines"

#: src/i18n/remote.tsx
msgid "{answered} of {total} answered"
msgstr "{answered} of {total} answered"

#: src/i18n/remote.tsx
msgid "{count, plural, one {# question} other {# questions}}"
msgstr "{count, plural, one {# question} other {# questions}}"

#: src/i18n/remote.tsx
msgid "{count} bytes"
msgstr "{count} bytes"

#: src/i18n/remote.tsx
msgid "{count} more files"
msgstr "{count} more files"

#: src/i18n/remote.tsx
msgid "{count} more output blocks"
msgstr "{count} more output blocks"

#: src/i18n/remote.tsx
msgid "{duration} ms"
msgstr "{duration} ms"

#: src/i18n/remote.tsx
msgid "{header} requires an answer."
msgstr "{header} requires an answer."

#: src/i18n/remote.tsx
msgid "{hours}h {remainingMinutes}m {remainder}s"
msgstr "{hours}h {remainingMinutes}m {remainder}s"

#: src/i18n/remote.tsx
msgid "{index}. {header}"
msgstr "{index}. {header}"

#: src/i18n/remote.tsx
msgid "{index}. {header}, answered"
msgstr "{index}. {header}, answered"

#: src/i18n/remote.tsx
msgid "{label} has an invalid length."
msgstr "{label} has an invalid length."

#: src/i18n/remote.tsx
msgid "{label} has an invalid number of selections."
msgstr "{label} has an invalid number of selections."

#: src/i18n/remote.tsx
msgid "{label} is outside the allowed range."
msgstr "{label} is outside the allowed range."

#: src/i18n/remote.tsx
msgid "{label} requires a value."
msgstr "{label} requires a value."

#: src/i18n/remote.tsx
msgid "{minutes}m {remainder}s"
msgstr "{minutes}m {remainder}s"

#: src/i18n/remote.tsx
msgid "{seconds}s"
msgstr "{seconds}s"

#: src/i18n/remote.tsx
msgid "{value} (last known)"
msgstr "{value} (last known)"

#: src/i18n/remote.tsx
msgid "Add feedback to request a revised plan."
msgstr "Add feedback to request a revised plan."

#: src/i18n/remote.tsx
msgid "Added"
msgstr "Added"

#: src/i18n/remote.tsx
msgid "Agent activity"
msgstr "Agent activity"

#: src/i18n/remote.tsx
msgid "Agent command failed."
msgstr "Agent command failed."

#: src/i18n/remote.tsx
msgid "Agent error"
msgstr "Agent error"

#: src/i18n/remote.tsx
msgid "Agent failed"
msgstr "Agent failed"

#: src/i18n/remote.tsx
msgid "Agent questions"
msgstr "Agent questions"

#: src/i18n/remote.tsx
msgid "Agent timeline"
msgstr "Agent timeline"

#: src/i18n/remote.tsx
msgid "Allow for session"
msgstr "Allow for session"

#: src/i18n/remote.tsx
msgid "Allow for turn"
msgstr "Allow for turn"

#: src/i18n/remote.tsx
msgid "Allow once"
msgstr "Allow once"

#: src/i18n/remote.tsx
msgid "Allow was offered with no approval scope."
msgstr "Allow was offered with no approval scope."

#: src/i18n/remote.tsx
msgid "Allowed · once"
msgstr "Allowed · once"

#: src/i18n/remote.tsx
msgid "Allowed · session"
msgstr "Allowed · session"

#: src/i18n/remote.tsx
msgid "Allowed · turn"
msgstr "Allowed · turn"

#: src/i18n/remote.tsx
msgid "Also changes the default for future sessions."
msgstr "Also changes the default for future sessions."

#: src/i18n/remote.tsx
msgid "Answered"
msgstr "Answered"

#: src/i18n/remote.tsx
msgid "Approve"
msgstr "Approve"

#: src/i18n/remote.tsx
msgid "Approve and execute"
msgstr "Approve and execute"

#: src/i18n/remote.tsx
msgid "Approved"
msgstr "Approved"

#: src/i18n/remote.tsx
msgid "Approved and resumed"
msgstr "Approved and resumed"

#: src/i18n/remote.tsx
msgid "Assistant"
msgstr "Assistant"

#: src/i18n/remote.tsx
msgid "Assistant message"
msgstr "Assistant message"

#: src/i18n/remote.tsx
msgid "Available"
msgstr "Available"

#: src/i18n/remote.tsx
msgid "Back to reference {reference}"
msgstr "Back to reference {reference}"

#: src/i18n/remote.tsx
msgid "Back to reference {reference}-{rereferenceIndex}"
msgstr "Back to reference {reference}-{rereferenceIndex}"

#: src/i18n/remote.tsx
msgid "Back to session controls"
msgstr "Back to session controls"

#: src/i18n/remote.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/i18n/remote.tsx
msgid "Canceled"
msgstr "Canceled"

#: src/i18n/remote.tsx
msgid "Cancellation requested."
msgstr "Cancellation requested."

#: src/i18n/remote.tsx
msgid "Changes apply to subsequent turns."
msgstr "Changes apply to subsequent turns."

#: src/i18n/remote.tsx
msgid "Choose…"
msgstr "Choose…"

#: src/i18n/remote.tsx
msgid "Close"
msgstr "Close"

#: src/i18n/remote.tsx
msgid "Close session controls"
msgstr "Close session controls"

#: src/i18n/remote.tsx
msgid "Close skill details"
msgstr "Close skill details"

#: src/i18n/remote.tsx
msgid "Closed"
msgstr "Closed"

#: src/i18n/remote.tsx
msgid "Command"
msgstr "Command"

#: src/i18n/remote.tsx
msgid "Command details"
msgstr "Command details"

#: src/i18n/remote.tsx
msgid "Completed"
msgstr "Completed"

#: src/i18n/remote.tsx
msgid "connect"
msgstr "connect"

#: src/i18n/remote.tsx
msgid "Connected"
msgstr "Connected"

#: src/i18n/remote.tsx
msgid "Connecting"
msgstr "Connecting"

#: src/i18n/remote.tsx
msgid "Connection"
msgstr "Connection"

#: src/i18n/remote.tsx
msgid "Connection unavailable"
msgstr "Connection unavailable"

#: src/i18n/remote.tsx
msgid "Console"
msgstr "Console"

#: src/i18n/remote.tsx
msgid "Context compaction"
msgstr "Context compaction"

#: src/i18n/remote.tsx
msgid "CONTINUE IN BROWSER"
msgstr "CONTINUE IN BROWSER"

#: src/i18n/remote.tsx
msgid "Custom response"
msgstr "Custom response"

#: src/i18n/remote.tsx
msgid "Decline"
msgstr "Decline"

#: src/i18n/remote.tsx
msgid "Declined"
msgstr "Declined"

#: src/i18n/remote.tsx
msgid "Deleted"
msgstr "Deleted"

#: src/i18n/remote.tsx
msgid "Denied"
msgstr "Denied"

#: src/i18n/remote.tsx
msgid "deny"
msgstr "deny"

#: src/i18n/remote.tsx
msgid "Deny"
msgstr "Deny"

#: src/i18n/remote.tsx
msgid "Detail renderer unavailable"
msgstr "Detail renderer unavailable"

#: src/i18n/remote.tsx
msgid "Diff for {path}"
msgstr "Diff for {path}"

#: src/i18n/remote.tsx
msgid "Diff preview for {path}"
msgstr "Diff preview for {path}"

#: src/i18n/remote.tsx
msgid "Directory"
msgstr "Directory"

#: src/i18n/remote.tsx
msgid "Disconnected. Values are last known; reconnect to change settings."
msgstr "Disconnected. Values are last known; reconnect to change settings."

#: src/i18n/remote.tsx
msgctxt "Interaction response"
msgid "Dismiss"
msgstr "Dismiss"

#: src/i18n/remote.tsx
msgid "Dismissed"
msgstr "Dismissed"

#: src/i18n/remote.tsx
msgid "Documentation is not available to preview."
msgstr "Documentation is not available to preview."

#: src/i18n/remote.tsx
msgid "Download resource"
msgstr "Download resource"

#: src/i18n/remote.tsx
msgid "Earlier activity could not be loaded."
msgstr "Earlier activity could not be loaded."

#: src/i18n/remote.tsx
msgid "Edit"
msgstr "Edit"

#: src/i18n/remote.tsx
msgid "Enter to send · Shift+Enter for a new line · / for commands"
msgstr "Enter to send · Shift+Enter for a new line · / for commands"

#: src/i18n/remote.tsx
msgid "Enter to send now · Shift+Enter for a new line · / for commands"
msgstr "Enter to send now · Shift+Enter for a new line · / for commands"

#: src/i18n/remote.tsx
msgid "Executing command"
msgstr "Executing command"

#: src/i18n/remote.tsx
msgid "Execution plan"
msgstr "Execution plan"

#: src/i18n/remote.tsx
msgid "Exit code {code}"
msgstr "Exit code {code}"

#: src/i18n/remote.tsx
msgid "EXTERNAL ACTION"
msgstr "EXTERNAL ACTION"

#: src/i18n/remote.tsx
msgid "Failed"
msgstr "Failed"

#: src/i18n/remote.tsx
msgid "File change"
msgstr "File change"

#: src/i18n/remote.tsx
msgid "File changes"
msgstr "File changes"

#: src/i18n/remote.tsx
msgid "File changes preview"
msgstr "File changes preview"

#: src/i18n/remote.tsx
msgid "filesystem"
msgstr "filesystem"

#: src/i18n/remote.tsx
msgid "Footnotes"
msgstr "Footnotes"

#: src/i18n/remote.tsx
msgid "FORM"
msgstr "FORM"

#: src/i18n/remote.tsx
msgid "from"
msgstr "from"

#: src/i18n/remote.tsx
msgid "Hidden answer"
msgstr "Hidden answer"

#: src/i18n/remote.tsx
msgid "Hide questions"
msgstr "Hide questions"

#: src/i18n/remote.tsx
msgid "I have completed this"
msgstr "I have completed this"

#: src/i18n/remote.tsx
msgid "In progress"
msgstr "In progress"

#: src/i18n/remote.tsx
msgid "INFORMATION REQUEST"
msgstr "INFORMATION REQUEST"

#: src/i18n/remote.tsx
msgid "Input accepted for the current turn."
msgstr "Input accepted for the current turn."

#: src/i18n/remote.tsx
msgid "INPUT REQUIRED"
msgstr "INPUT REQUIRED"

#: src/i18n/remote.tsx
msgid "Interaction response failed."
msgstr "Interaction response failed."

#: src/i18n/remote.tsx
msgid "Interaction unavailable"
msgstr "Interaction unavailable"

#: src/i18n/remote.tsx
msgid "Interrupt"
msgstr "Interrupt"

#: src/i18n/remote.tsx
msgid "Interrupt failed."
msgstr "Interrupt failed."

#: src/i18n/remote.tsx
msgid "Interrupt is unavailable for this Provider."
msgstr "Interrupt is unavailable for this Provider."

#: src/i18n/remote.tsx
msgid "Interrupt requested"
msgstr "Interrupt requested"

#: src/i18n/remote.tsx
msgid "Interrupt the current native operation"
msgstr "Interrupt the current native operation"

#: src/i18n/remote.tsx
msgid "Interrupting…"
msgstr "Interrupting…"

#: src/i18n/remote.tsx
msgid "Invalid interaction request"
msgstr "Invalid interaction request"

#: src/i18n/remote.tsx
msgid "Let the native Provider handle this after the current turn"
msgstr "Let the native Provider handle this after the current turn"

#: src/i18n/remote.tsx
msgid "Live provider controls"
msgstr "Live provider controls"

#: src/i18n/remote.tsx
msgid "Load earlier activity"
msgstr "Load earlier activity"

#: src/i18n/remote.tsx
msgid "Load resource"
msgstr "Load resource"

#: src/i18n/remote.tsx
msgid "Loading documentation…"
msgstr "Loading documentation…"

#: src/i18n/remote.tsx
msgid "Loading earlier activity…"
msgstr "Loading earlier activity…"

#: src/i18n/remote.tsx
msgid "Loading native commands…"
msgstr "Loading native commands…"

#: src/i18n/remote.tsx
msgid "Loading resource…"
msgstr "Loading resource…"

#: src/i18n/remote.tsx
msgid "Markdown table"
msgstr "Markdown table"

#: src/i18n/remote.tsx
msgid "Message"
msgstr "Message"

#: src/i18n/remote.tsx
msgid "Message queued by Provider."
msgstr "Message queued by Provider."

#: src/i18n/remote.tsx
msgid "Message sent."
msgstr "Message sent."

#: src/i18n/remote.tsx
msgid "Message the Agent…"
msgstr "Message the Agent…"

#: src/i18n/remote.tsx
msgid "Model"
msgstr "Model"

#: src/i18n/remote.tsx
msgid "Model settings"
msgstr "Model settings"

#: src/i18n/remote.tsx
msgid "Model: {value}"
msgstr "Model: {value}"

#: src/i18n/remote.tsx
msgid "Modified"
msgstr "Modified"

#: src/i18n/remote.tsx
msgid "Native command failed."
msgstr "Native command failed."

#: src/i18n/remote.tsx
msgid "Native commands"
msgstr "Native commands"

#: src/i18n/remote.tsx
msgid "network"
msgstr "network"

#: src/i18n/remote.tsx
msgid "Next"
msgstr "Next"

#: src/i18n/remote.tsx
msgid "No"
msgstr "No"

#: src/i18n/remote.tsx
msgid "No answer provided"
msgstr "No answer provided"

#: src/i18n/remote.tsx
msgid "No answers"
msgstr "No answers"

#: src/i18n/remote.tsx
msgid "No diff content provided."
msgstr "No diff content provided."

#: src/i18n/remote.tsx
msgid "No file changes reported."
msgstr "No file changes reported."

#: src/i18n/remote.tsx
msgid "No matching native commands."
msgstr "No matching native commands."

#: src/i18n/remote.tsx
msgid "No output."
msgstr "No output."

#: src/i18n/remote.tsx
msgid "No results."
msgstr "No results."

#: src/i18n/remote.tsx
msgid "No timeline activity."
msgstr "No timeline activity."

#: src/i18n/remote.tsx
msgid "Normal chat"
msgstr "Normal chat"

#: src/i18n/remote.tsx
msgid "Not provided"
msgstr "Not provided"

#: src/i18n/remote.tsx
msgid "Off"
msgstr "Off"

#: src/i18n/remote.tsx
msgid "On"
msgstr "On"

#: src/i18n/remote.tsx
msgid "Open {host}"
msgstr "Open {host}"

#: src/i18n/remote.tsx
msgid "Open chat commands"
msgstr "Open chat commands"

#: src/i18n/remote.tsx
msgid "Open or attach to an Agent first."
msgstr "Open or attach to an Agent first."

#: src/i18n/remote.tsx
msgid "Open resource"
msgstr "Open resource"

#: src/i18n/remote.tsx
msgid "Opening…"
msgstr "Opening…"

#: src/i18n/remote.tsx
msgid "Output"
msgstr "Output"

#: src/i18n/remote.tsx
msgid "Partially answered"
msgstr "Partially answered"

#: src/i18n/remote.tsx
msgid "Pending"
msgstr "Pending"

#: src/i18n/remote.tsx
msgid "Pending interactions"
msgstr "Pending interactions"

#: src/i18n/remote.tsx
msgid "PERMISSION REQUEST"
msgstr "PERMISSION REQUEST"

#: src/i18n/remote.tsx
msgid "Permission settings"
msgstr "Permission settings"

#: src/i18n/remote.tsx
msgid "Permissions"
msgstr "Permissions"

#: src/i18n/remote.tsx
msgid "PERMISSIONS"
msgstr "PERMISSIONS"

#: src/i18n/remote.tsx
msgid "Permissions: {value}"
msgstr "Permissions: {value}"

#: src/i18n/remote.tsx
msgid "PLAN REVIEW"
msgstr "PLAN REVIEW"

#: src/i18n/remote.tsx
msgid "Planning"
msgstr "Planning"

#: src/i18n/remote.tsx
msgid "Planning can change only while connected and idle, with no pending interactions."
msgstr "Planning can change only while connected and idle, with no pending interactions."

#: src/i18n/remote.tsx
msgid "Planning is not supported by this session."
msgstr "Planning is not supported by this session."

#: src/i18n/remote.tsx
msgid "Planning mode"
msgstr "Planning mode"

#: src/i18n/remote.tsx
msgid "Planning mode could not be changed."
msgstr "Planning mode could not be changed."

#: src/i18n/remote.tsx
msgid "Planning mode is read-only for this session."
msgstr "Planning mode is read-only for this session."

#: src/i18n/remote.tsx
msgid "Previous"
msgstr "Previous"

#: src/i18n/remote.tsx
msgid "Prompt"
msgstr "Prompt"

#: src/i18n/remote.tsx
msgid "Provider"
msgstr "Provider"

#: src/i18n/remote.tsx
msgid "Provider confirmed. Changes apply to the next message."
msgstr "Provider confirmed. Changes apply to the next message."

#: src/i18n/remote.tsx
msgid "Query"
msgstr "Query"

#: src/i18n/remote.tsx
msgid "Questions"
msgstr "Questions"

#: src/i18n/remote.tsx
msgid "Queue"
msgstr "Queue"

#: src/i18n/remote.tsx
msgid "Queue for next turn"
msgstr "Queue for next turn"

#: src/i18n/remote.tsx
msgid "Queueing…"
msgstr "Queueing…"

#: src/i18n/remote.tsx
msgid "Raw result"
msgstr "Raw result"

#: src/i18n/remote.tsx
msgid "read"
msgstr "read"

#: src/i18n/remote.tsx
msgid "Read"
msgstr "Read"

#: src/i18n/remote.tsx
msgid "Ready"
msgstr "Ready"

#: src/i18n/remote.tsx
msgid "Reasoning trace"
msgstr "Reasoning trace"

#: src/i18n/remote.tsx
msgid "Referenced resources"
msgstr "Referenced resources"

#: src/i18n/remote.tsx
msgid "Rejected"
msgstr "Rejected"

#: src/i18n/remote.tsx
msgid "REMOTE SESSION"
msgstr "REMOTE SESSION"

#: src/i18n/remote.tsx
msgid "Remove skill {name}"
msgstr "Remove skill {name}"

#: src/i18n/remote.tsx
msgid "Renamed"
msgstr "Renamed"

#: src/i18n/remote.tsx
msgid "Request changes"
msgstr "Request changes"

#: src/i18n/remote.tsx
msgid "Request revision"
msgstr "Request revision"

#: src/i18n/remote.tsx
msgid "Required"
msgstr "Required"

#: src/i18n/remote.tsx
msgid "Resource request failed."
msgstr "Resource request failed."

#: src/i18n/remote.tsx
msgid "Resources"
msgstr "Resources"

#: src/i18n/remote.tsx
msgid "Result"
msgstr "Result"

#: src/i18n/remote.tsx
msgid "Result truncated to fit the timeline."
msgstr "Result truncated to fit the timeline."

#: src/i18n/remote.tsx
msgid "Retry"
msgstr "Retry"

#: src/i18n/remote.tsx
msgid "Retry documentation"
msgstr "Retry documentation"

#: src/i18n/remote.tsx
msgid "Return here after completing the action."
msgstr "Return here after completing the action."

#: src/i18n/remote.tsx
msgid "Review proposed plan"
msgstr "Review proposed plan"

#: src/i18n/remote.tsx
msgid "Review requested access"
msgstr "Review requested access"

#: src/i18n/remote.tsx
msgid "Revision feedback"
msgstr "Revision feedback"

#: src/i18n/remote.tsx
msgid "Running"
msgstr "Running"

#: src/i18n/remote.tsx
msgid "Runtime"
msgstr "Runtime"

#: src/i18n/remote.tsx
msgid "Runtime notice"
msgstr "Runtime notice"

#: src/i18n/remote.tsx
msgid "Saved history"
msgstr "Saved history"

#: src/i18n/remote.tsx
msgid "Selected skill"
msgstr "Selected skill"

#: src/i18n/remote.tsx
msgid "Send input to the active native turn"
msgstr "Send input to the active native turn"

#: src/i18n/remote.tsx
msgid "Send message"
msgstr "Send message"

#: src/i18n/remote.tsx
msgid "Sending…"
msgstr "Sending…"

#: src/i18n/remote.tsx
msgid "Session"
msgstr "Session"

#: src/i18n/remote.tsx
msgid "Session controls"
msgstr "Session controls"

#: src/i18n/remote.tsx
msgid "Session planning mode"
msgstr "Session planning mode"

#: src/i18n/remote.tsx
msgid "Session setting could not be changed."
msgstr "Session setting could not be changed."

#: src/i18n/remote.tsx
msgid "Session status"
msgstr "Session status"

#: src/i18n/remote.tsx
msgid "Session status and planning"
msgstr "Session status and planning"

#: src/i18n/remote.tsx
msgid "Session subagents"
msgstr "Session subagents"

#: src/i18n/remote.tsx
msgid "Settings can change only while idle with no pending interactions."
msgstr "Settings can change only while idle with no pending interactions."

#: src/i18n/remote.tsx
msgid "Show details"
msgstr "Show details"

#: src/i18n/remote.tsx
msgid "Show full result"
msgstr "Show full result"

#: src/i18n/remote.tsx
msgid "Show questions"
msgstr "Show questions"

#: src/i18n/remote.tsx
msgid "Skill"
msgstr "Skill"

#: src/i18n/remote.tsx
msgid "Skill details"
msgstr "Skill details"

#: src/i18n/remote.tsx
msgid "Start a new native turn"
msgstr "Start a new native turn"

#: src/i18n/remote.tsx
msgid "Starting"
msgstr "Starting"

#: src/i18n/remote.tsx
msgid "Status"
msgstr "Status"

#: src/i18n/remote.tsx
msgid "Steer"
msgstr "Steer"

#: src/i18n/remote.tsx
msgid "Steer current turn"
msgstr "Steer current turn"

#: src/i18n/remote.tsx
msgid "Steering…"
msgstr "Steering…"

#: src/i18n/remote.tsx
msgid "Subagents"
msgstr "Subagents"

#: src/i18n/remote.tsx
msgid "Submit"
msgstr "Submit"

#: src/i18n/remote.tsx
msgid "Submit response"
msgstr "Submit response"

#: src/i18n/remote.tsx
msgid "Submitted"
msgstr "Submitted"

#: src/i18n/remote.tsx
msgid "Submitting…"
msgstr "Submitting…"

#: src/i18n/remote.tsx
msgid "TASK BOARD"
msgstr "TASK BOARD"

#: src/i18n/remote.tsx
msgid "The host cannot respond to this external action request."
msgstr "The host cannot respond to this external action request."

#: src/i18n/remote.tsx
msgid "The host cannot respond to this form request."
msgstr "The host cannot respond to this form request."

#: src/i18n/remote.tsx
msgid "The host cannot respond to this permission approval request."
msgstr "The host cannot respond to this permission approval request."

#: src/i18n/remote.tsx
msgid "The host cannot respond to this plan approval request."
msgstr "The host cannot respond to this plan approval request."

#: src/i18n/remote.tsx
msgid "The host cannot respond to this question request."
msgstr "The host cannot respond to this question request."

#: src/i18n/remote.tsx
msgid "The host cannot respond to this tool approval request."
msgstr "The host cannot respond to this tool approval request."

#: src/i18n/remote.tsx
msgid "The recorded interaction response does not match its request."
msgstr "The recorded interaction response does not match its request."

#: src/i18n/remote.tsx
msgid "The requested link cannot be opened."
msgstr "The requested link cannot be opened."

#: src/i18n/remote.tsx
msgid "This answer is hidden in conversation history."
msgstr "This answer is hidden in conversation history."

#: src/i18n/remote.tsx
msgid "This Provider can invoke skills when the current turn finishes."
msgstr "This Provider can invoke skills when the current turn finishes."

#: src/i18n/remote.tsx
msgid "This Provider does not expose native commands."
msgstr "This Provider does not expose native commands."

#: src/i18n/remote.tsx
msgid "This Provider does not expose these session settings."
msgstr "This Provider does not expose these session settings."

#: src/i18n/remote.tsx
msgid "This Provider exposes a description without full documentation."
msgstr "This Provider exposes a description without full documentation."

#: src/i18n/remote.tsx
msgid "This subagent could not be opened."
msgstr "This subagent could not be opened."

#: src/i18n/remote.tsx
msgid "TOOL APPROVAL"
msgstr "TOOL APPROVAL"

#: src/i18n/remote.tsx
msgid "TOOL AUTHORIZATION"
msgstr "TOOL AUTHORIZATION"

#: src/i18n/remote.tsx
msgid "Tool result"
msgstr "Tool result"

#: src/i18n/remote.tsx
msgid "Trigger: automatic"
msgstr "Trigger: automatic"

#: src/i18n/remote.tsx
msgid "Trigger: manual"
msgstr "Trigger: manual"

#: src/i18n/remote.tsx
msgid "Turn elapsed time"
msgstr "Turn elapsed time"

#: src/i18n/remote.tsx
msgid "Unable to load native commands."
msgstr "Unable to load native commands."

#: src/i18n/remote.tsx
msgid "Unable to load skill documentation."
msgstr "Unable to load skill documentation."

#: src/i18n/remote.tsx
msgid "Unavailable"
msgstr "Unavailable"

#: src/i18n/remote.tsx
msgid "Unknown interaction"
msgstr "Unknown interaction"

#: src/i18n/remote.tsx
msgid "Unknown or unavailable native command. Open / to refresh the command list."
msgstr "Unknown or unavailable native command. Open / to refresh the command list."

#: src/i18n/remote.tsx
msgid "Unsupported interaction"
msgstr "Unsupported interaction"

#: src/i18n/remote.tsx
msgid "URL"
msgstr "URL"

#: src/i18n/remote.tsx
msgid "User message"
msgstr "User message"

#: src/i18n/remote.tsx
msgid "View skill {name}"
msgstr "View skill {name}"

#: src/i18n/remote.tsx
msgid "Waiting for Provider confirmation."
msgstr "Waiting for Provider confirmation."

#: src/i18n/remote.tsx
msgid "Waiting for Provider planning state."
msgstr "Waiting for Provider planning state."

#: src/i18n/remote.tsx
msgid "Waiting for response"
msgstr "Waiting for response"

#: src/i18n/remote.tsx
msgid "What should the Agent change?"
msgstr "What should the Agent change?"

#: src/i18n/remote.tsx
msgid "Working"
msgstr "Working"

#: src/i18n/remote.tsx
msgid "write"
msgstr "write"

#: src/i18n/remote.tsx
msgid "Write"
msgstr "Write"

#: src/i18n/remote.tsx
msgid "Yes"
msgstr "Yes"

#: src/i18n/remote.tsx
msgid "You"
msgstr "You"
